import { TFunction } from 'i18next'

import { Account } from '@modules-deprecated/app/accounts/types'

interface GetDisplayTitleParams {
  account: Account
  isClosed?: boolean
  t: TFunction
}

export const getDisplayTitle = ({ account, isClosed, t }: GetDisplayTitleParams) => {
  const accountNo = account.accountNo ? `${account.accountNo} - ` : ''
  const closed = isClosed ? ` (${t('bank_account_select.account_closed_label')})` : ''

  return `${accountNo}${account.name}${closed}`
}
